import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    userLogin,
    forgotPassword,
    resetPassword,
    createUser,
    getUsers,
    getUsersFind,
    updateUser,
    updateUserAdviser,
    updateUserOwner,
    disabledClientsAdviser,
    getUsersReport,
}

function createUser(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/users`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function userLogin(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/login`)
           .send(data)
           .end((err, res) => {

                if(!err && res.body) {
                    Storage.setItem('user', res.body.data.user)
                    Storage.setItem('access', res.body.data.access)
                }

               resolve(res.body)
           })
    })
}

function forgotPassword(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/password/forgot`)
           .send(data)
           .end((err, res) => {
               resolve(res && res.body ? res.body : networkError())
           })
    })
}

function resetPassword(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/password/reset`)
           .send(data)
           .end((err, res) => {
               resolve(res && res.body ? res.body : networkError())
           })
    })
}

function networkError() {
    return {
        success: false,
        error: { message: 'No se pudo conectar con el servidor, intenta de nuevo' }
    }
}

function getUsers(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/users`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getUsersFind(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/users/find`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateUser(userId, data) {
    return new Promise((resolve, reject) => {

        Superagent
           .put(`${HOST_API}/users`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateUserAdviser(userId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/users/${userId}/adviser`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateUserOwner(userId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/users/${userId}/owner`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function disabledClientsAdviser(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/users/${userId}/clients/disabled`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getUsersReport() {
    return new Promise((resolve, reject) => {

        Superagent
            .get(`${HOST_API}/users/report`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
